module.exports = __webpack_public_path__ + "static/media/empty-barchart.8c2a4475.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/empty-barchart.svg
// module id = ./src/common/assets/empty-barchart.svg
// module chunks = 18